let baseUrl = `${window.location.protocol}//${window.location.host}/`;
if (baseUrl.indexOf('localhost') > -1) {
    baseUrl = `${baseUrl}MywaveElements/`;
}

const publicPath = `${baseUrl}js/zui/dist/${process.env.ZUI_PATH}/`;

__webpack_public_path__ = publicPath;
__webpack_require__.p = publicPath;
